/**
 * This controls the Accept/Decline and other buttons in the button stack for Activity Detail Pages
 */
import $ from 'jquery'

import ModalView from 'component/modal/modal'
import PaywallView from 'component/paywall/paywall'
import EventDetailsButtonStackView from 'bundle/event_promotion/view/button_stack'
import PrintGuestlistView from 'bundle/event_guestlist/view/print_guestlist_modal'

export default EventDetailsButtonStackView.extend({
    events() {
        const parentEvents = EventDetailsButtonStackView.prototype.events
        const events = typeof parentEvents === 'function' ? parentEvents.call(this) : parentEvents

        return Object.assign({}, events, {
            'click .js-should-join-group-modal-trigger': '_onShouldJoinGroupModalTriggerClick',
            'click .js-print-guestlist-trigger': '_onPrintGuestlistTriggerClick',
        })
    },

    _initializePaywall() {
        this.initSubview(PaywallView, {
            el: this.$('.js-paywall-attendance'),
            paywallType: this.options.entityType,
            paywallEntityId: this.options.entityId,
            upgradeHandler: this.options.upgradeHandler,
            upgradeHandlerParameters: this.options.upgradeHandlerParameters,
        })
    },

    _onShouldJoinGroupModalTriggerClick(event) {
        const modalOptions = ModalView.getSubData($(event.target))
        this.initSubview(ModalView, modalOptions)
    },

    _onPrintGuestlistTriggerClick(event) {
        this.initSubview(PrintGuestlistView, {
            el: this.$('.js-print-guestlist-trigger'),
            url: $(event.target).data('href'),
        })
    },
})
